import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import PublicDeck from "@/pages/PublicDeck";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(10,10,10,0.9)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
        <div className="min-h-screen p-6 md:p-14 lg:p-20 flex justify-center">
          <div className="kd-stage w-full max-w-[1400px] min-h-[calc(100vh-48px)] md:min-h-[calc(100vh-112px)] lg:min-h-[calc(100vh-160px)]">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/create" element={<Wizard />} />
                <Route path="/create/:projectId" element={<Wizard />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/deck/:token" element={<PublicDeck />} />
                <Route path="/payment/success" element={<PaymentResult status="success" />} />
                <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
              </Routes>
            </BrowserRouter>
          </div>
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
